// extracted by mini-css-extract-plugin
module.exports = {"backButton":"PopupHeader_backButton__I-6Fo","content":"PopupHeader_content__2Nhor","wrapper":"PopupHeader_wrapper__3y8wZ"};